import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AuthCodeGrantComponent } from 'app/connect/auth-code-grant/auth-code-grant.component';
import { CredentialTokenOauth } from 'app/connect/auth-code-grant/core/CredentialTokenOauth';
import { DefatultMetaParam } from 'app/connect/core/TriggerConnection';

import { MessageService } from 'app/connect/core/message.service';
import { services } from 'app/connect/core/trigger.enum';
import { Utils } from 'app/connect/core/trigger.util';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { UtilsService } from 'app/environment/services/utils.service';
import { ShowToastService } from 'app/shared/services/showToast.service';
import { I18nService } from 'i18n/i18n.service';



@Component({
  selector: 'biz-connect-triggers-detail',
  templateUrl: './connect-triggers-detail.component.html',
  styleUrls: ['./connect-triggers-detail.component.scss']
})
export class ConnectTriggersDetailComponent {

  @Input() selectedTriggerConn: ITriggerConnection;
  @Input() redirecUrl: string;

  @ViewChild('triggerForm', { static: false}) triggerForm: NgForm;
  @ViewChild('authcodegrant', { static: false}) authcodegrant: AuthCodeGrantComponent;

  public cellSpacingMode = 'compact';
  public selectedTab: number = 0;
  authProperties: IPropertyMeta[];
  authPropertiesShow: IPropertyMeta[];
  needAuthorize = false;
  tokenCredentials: ITokenCredentials;
  selectedTriggerOriginal: ITriggerConnection;

  constructor(public utilsService: UtilsService, private _cryptoDataService: CryptoDataService,
    private messageService: MessageService, private _translateService: TranslateService,
    private _showToastService: ShowToastService, private _i18nService: I18nService) { }

  async ngOnChanges() {
    this.selectedTab = 0;

    this.loadPropertiesDataInMetadata();
    this.needAuthorize = this.selectedTriggerConn.serviceName == services.dropbox;
    this.tokenCredentials = null;
    this.selectedTriggerConn.environment.currentEnvironment.params.needAuth = this.needAuthorize;
    this.selectedTriggerOriginal = Utils.copyObject(this.selectedTriggerConn);
    Utils.copyMetaproperties(this.selectedTriggerConn, this.selectedTriggerOriginal);
    this.updateModel(!this.selectedTriggerConn.environment.currentEnvironment.isEnabled);
  }

  loadPropertiesDataInMetadata() {
    let defaultConfig = new DefatultMetaParam();
    var params = this.selectedTriggerConn.environment.currentEnvironment.params;
    let metaPropierties = defaultConfig.loadMetaParamListByOauthType(this.selectedTriggerConn.serviceName, this.redirecUrl);
    if (params) {
      params.metaProperties = metaPropierties;
      if (params.authentication) {
        defaultConfig.copyDataToMetaParameters(params.metaProperties, params.authentication);
        defaultConfig.updateRedirecUri(params.metaProperties, this.redirecUrl);
      }
    }
    this.setAuthProperties(metaPropierties);
  }

  updateModel(switchEnable){
    this.authProperties.forEach(prop => prop.disabled = switchEnable);
    this.setAuthProperties(this.authProperties);
  }

  setAuthProperties(metaProperties: IPropertyMeta[]) {
    this.authProperties = metaProperties;
    this.authPropertiesShow = this.authProperties.filter(prop => !prop.hidden);
  }

  onOauthData(credentialTokenOauth: CredentialTokenOauth) {
    if (credentialTokenOauth) {
      this.tokenCredentials = {
        expiresIn: credentialTokenOauth.expiresIn,
        accessToken: credentialTokenOauth.token,
        accessTokenCreationDateUtc: credentialTokenOauth.creationDate,
        refreshToken: credentialTokenOauth.refreshToken,
      }
      this.selectedTriggerConn.environment.currentEnvironment.params.tokenCredentials = this.tokenCredentials;
    }
  }

  authorize() {
    let properties = this.authProperties.map(auth => auth.clone());
    Utils.trimToProperties(properties);
    if (Utils.validateProperties(properties, this._translateService, this.messageService)) {
      this.decrypProperties(properties, this._cryptoDataService, () => {
        let oath2CodeGrantURL = this.buildPetition(properties);
        let propertiesList = properties.map(function (m) {
          return { "key": m.name, "value": m.value };
        });
        this.authcodegrant.openWindow(oath2CodeGrantURL, propertiesList);
      });
    }
  }

  async decrypProperties(properties: IPropertyMeta[], _cryptoDataService, callback) {
    for (let i = 0; i < properties.length; i++) {
      let prop = properties[i];
      if (prop.passwordmode && this.validIgnoreProperties(prop.name)) {
        prop.value = await this._cryptoDataService.decryptString(prop.value);
      }
    }
    callback();
  }

  buildPetition(properties: IPropertyMeta[]) {
    let url = properties.find(pro => pro.name == "auth_url").value;
    //Add properties
    let parameters;
    properties.filter(pro => this.validIgnoreProperties(pro.name)).forEach(async f => {
      var param = f.name + "=" + f.value;
      if (parameters) {
        parameters = parameters + "&" + param
      } else {
        parameters = param;
      }
    });
    return url + "?" + parameters;
  }

  validIgnoreProperties(name: string) {
    var ignoreProper = ["auth_url", "token_url", "client_secret"];
    return !ignoreProper.some(p => p == name);
  }
  public isValid(): boolean {
    return !this.triggerForm || this.triggerForm.valid;
  }

  authenticated() {
    var params = this.selectedTriggerConn.environment.currentEnvironment.params;
    if (params && params.tokenCredentials && params.tokenCredentials.accessToken) {
      return true;
    } else {
      return false;
    }
  }

  changeProperty(event) {
    if (event) {
      if (this.selectedTriggerConn.environment.currentEnvironment.params && this.selectedTriggerConn.environment.currentEnvironment.params.tokenCredentials) {
        this.selectedTriggerConn.environment.currentEnvironment.params.tokenCredentials = null;
      }
    }
  }

  areThereAnyPendingChanges() {    
    return !(JSON.stringify(this.selectedTriggerConn) === JSON.stringify(this.selectedTriggerOriginal));
  }
  copyToclipboard(value) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this._showToastService.showToast(this._i18nService.instant('GLOBAL.TEXT_COPIED'), 'success');
  }
}
